import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  AdminSpecificLeave,
  RejoinApproval,
  UpdateAdminLeaveStatus
} from "../../Repository/Api";
import { imagepath } from "../../Repository/BaseUrl";
import { NonEmptyValidation } from "../../Store/validate";
import { NumberOfDays } from "../Common/FinancialYear";
import CustomModal from "../CustomModal";
import { errorMsg, successMsg } from "../Toastify";
const AdminSpecificrequestview = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const { id } = useParams();
  const navigate = useNavigate();

  const [SpecificProfile, setSecificProfile] = useState({});
  const [statusAcceptModel, setStatusAcceptModel] = useState(false);
  const [createStatus, setCreateStatus] = useState([]);
  const [validation, setValidation] = useState({});
  const [rejoinValidation, setRejoinValidation] = useState({});
  const [compensation_date, setCompensation_date] = useState([]);
  const [rejoinComment, setRejoinComment] = useState('');
  const [rejoinModal, setRejoinModal] = useState(false);
  // console.log(SpecificProfile)
  useEffect(() => {
    getSpecificlist();
  }, [id]);

  const getSpecificlist = async () => {
    const response = await AdminSpecificLeave(id, token);
    if (response && response.statusCode === 200) {
      setSecificProfile(response.data);
    } else {
      errorMsg(response.message);
    }
  };
  const setData = (e, key) => {
    let TempData = createStatus;
    TempData[key] = e;
    setCreateStatus(TempData);
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };
  const CheckValidation = () => {
    let Status = true,
      validdateData = {};
    if (!createStatus.admin_comment) {
      validdateData.admin_comment = "Comment is Required";
      Status = false;
    }
    setValidation({ ...validation, ...validdateData });
    return Status;
  };
  const handleRejoinSubmit = async (e) => {
    let validate = {}
    validate = NonEmptyValidation(rejoinComment)
    setRejoinValidation(validate)
    e.preventDefault();
    const Payload = {
      id: SpecificProfile?.joining_report_details?.id,
      status: "approved",
      comment: rejoinComment,
    };
    if (rejoinComment) {
      const response = await RejoinApproval(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setRejoinModal(false);
        navigate(-1)
      } else {
        errorMsg(response.message);
      }
    }
  };
  const handleApproveSubmit = async (e) => {
    e.preventDefault();
    const Payload = {
      id: id,
      status: "forwarded",
      admin_comment: createStatus.admin_comment,
    };
    if (CheckValidation()) {
      const response = await UpdateAdminLeaveStatus(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateStatus({});
        e.target.reset();
        setStatusAcceptModel(false);
        window.location.reload();
      } else {
        errorMsg(response.message);
      }
    }
  };

  // console.log(SpecificProfile?.no_of_days)

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle">
                  <span
                    className="arrowicon"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    ← &nbsp;
                  </span>
                  Leave Request List
                </h6>
                <div className="row">
                  <div className="col-lg-3">
                    <label className="labeltext">Name of the Applicant</label>
                    <input
                      type="text"
                      className="fieldinput"
                      value={SpecificProfile?.first_name + " " + SpecificProfile?.last_name}
                      disabled
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext">Designation</label>
                    <input
                      type="text"
                      className="fieldinput"
                      value={SpecificProfile?.designation}
                      disabled
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext">Department</label>
                    <input
                      type="text"
                      className="fieldinput"
                      value={SpecificProfile?.department}
                      disabled
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext"> Nature of Leave </label>
                    <input
                      type="text"
                      className="fieldinput"
                      defaultValue={SpecificProfile?.nature_of_leave}
                      disabled
                    />
                  </div>
                  {SpecificProfile?.nature_of_leave_code === "permissions" ?
                    <>
                      <div className="col-lg-3">
                        <label className="labeltext">
                          {SpecificProfile?.nature_of_leave_code === "permissions" ? 'Total Hours' :
                            '  No. of Days'}

                        </label>
                        <input
                          type="text"
                          className="fieldinput"
                          defaultValue={SpecificProfile?.no_of_days?.toFixed(2)}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">Permission Date</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={moment(SpecificProfile?.start_date).format(
                            "DD-MM-yyyy"
                          )}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">Start Time</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={moment(SpecificProfile?.start_date).utcOffset('+05:30').format('hh:mm')}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">End Time</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={moment(SpecificProfile?.end_date).utcOffset('+05:30').format('hh:mm')}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">Reason</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={SpecificProfile?.reason}
                          disabled
                        />
                      </div>
                    </> :
                    <>
                      {SpecificProfile?.duration_type === "half_day" ? (
                        <>
                          <div className="col-lg-3">
                            <label className="labeltext"> Duration Type</label>
                            <input
                              type="text"
                              className="fieldinput"
                              defaultValue={SpecificProfile?.duration_type}
                              disabled
                            />
                          </div>
                          <div className="col-lg-3">
                            <label className="labeltext"> Half Day Type</label>
                            <input
                              type="text"
                              className="fieldinput"
                              defaultValue={SpecificProfile?.half_day_leave_type}
                              disabled
                            />
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {SpecificProfile?.commuted_type ? (
                        <div className="col-lg-3">
                          <label className="labeltext"> Commuted Type</label>
                          <input
                            type="text"
                            className="fieldinput"
                            value={
                              SpecificProfile?.commuted_type !== undefined
                                ? SpecificProfile.commuted_type
                                  .toString()
                                  .replace(/half_pay/g, "Half Pay")
                                  .replace(/full_pay/g, "Full Pay")
                                : ""
                            }
                            disabled
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      {SpecificProfile?.nature_of_leave ===
                        "Special Casual Leave (SCL)" ||
                        SpecificProfile?.nature_of_leave === "On Duty" ? (
                        <>
                          <div className="col-lg-3">
                            <label className="labeltext">
                              Title of the Program
                            </label>
                            <input
                              type="text"
                              className="fieldinput"
                              defaultValue={SpecificProfile?.title_of_the_program}
                              disabled
                            />
                          </div>
                          <div className="col-lg-3">
                            <label className="labeltext">Topic</label>
                            <input
                              type="text"
                              className="fieldinput"
                              defaultValue={SpecificProfile?.topic}
                              disabled
                            />
                          </div>
                          <div className="col-lg-3">
                            <label className="labeltext">Organized By</label>
                            <input
                              type="text"
                              className="fieldinput"
                              defaultValue={SpecificProfile?.organized_by}
                              disabled
                            />
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {SpecificProfile?.nature_of_leave ===
                        "Child Care Leave (CCL)" ? (
                        <>
                          <div className="col-lg-3">
                            <label className="labeltext">Child Name</label>
                            <input
                              type="text"
                              className="fieldinput"
                              defaultValue={SpecificProfile?.children_detail?.name}
                              disabled
                            />
                          </div>
                          <div className="col-lg-3">
                            <label className="labeltext">Child DOB</label>
                            <input
                              type="text"
                              className="fieldinput"
                              defaultValue={moment(
                                SpecificProfile?.children_detail?.dob
                              ).format("DD-MM-yyyy")}
                              disabled
                            />
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      <div className="col-lg-3">
                        <label className="labeltext"> No. of Days</label>
                        <input
                          type="text"
                          className="fieldinput"
                          defaultValue={SpecificProfile?.no_of_days}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">Leave Start Date</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={moment(SpecificProfile?.start_date).format(
                            "DD-MM-yyyy"
                          )}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">Leave End Date</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={moment(SpecificProfile?.end_date).format(
                            "DD-MM-yyyy"
                          )}
                          disabled
                        />
                      </div>
                      {SpecificProfile?.prefix ? (
                        <div className="col-lg-3">
                          <label className="labeltext"> Prefix</label>
                          <input
                            type="text"
                            className="fieldinput"
                            value={moment(SpecificProfile?.prefix).format(
                              "DD-MM-yyyy"
                            )}
                            disabled
                          />
                          <br />
                          <small>
                            No of prefix Holidays :
                            <span className="fw-bold ms-2">
                              {NumberOfDays(SpecificProfile?.prefix, SpecificProfile?.start_date)}
                            </span>
                          </small>
                        </div>
                      ) : (
                        ""
                      )}
                      {SpecificProfile?.suffix ? (
                        <div className="col-lg-3">
                          <label className="labeltext"> Suffix</label>
                          <input
                            type="text"
                            className="fieldinput"
                            value={moment(SpecificProfile?.suffix).format(
                              "DD-MM-yyyy"
                            )}
                            disabled
                          />
                          <br />
                          <small>
                            No of suffix Holidays :
                            <span className="fw-bold ms-2">
                              {SpecificProfile?.no_of_days !== 1 ?
                                NumberOfDays(SpecificProfile?.end_date, SpecificProfile?.suffix) :
                                NumberOfDays(SpecificProfile?.start_date, SpecificProfile?.suffix)
                              }
                            </span>
                          </small>
                        </div>
                      ) : (
                        ""
                      )}
                      {SpecificProfile?.hod_alternate_person_name ? (
                        <div className="col-lg-3">
                          <label className="labeltext">Hod Alternate Person</label>
                          <input
                            type="text"
                            className="fieldinput"
                            value={SpecificProfile?.hod_alternate_person_name}
                            disabled
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      {SpecificProfile?.compensation_date ? (
                        <div className="col-lg-3">
                          <label className="labeltext">Worked Date</label>
                          <textarea
                            type="text"
                            className="fieldinput"
                            value={
                              SpecificProfile?.compensation_date_details?.map((item, i) => (
                                moment(item.date).format("DD-MM-yyyy")
                              )).join(', ')}
                            disabled
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      {SpecificProfile?.nature_of_leave === "Out Of Station" ? (
                        ""
                      ) : (
                        <>
                          {
                            (SpecificProfile?.alternate !== '') &&
                            <div className="col-lg-3">
                              <label className="labeltext">Alternate</label>
                              <input
                                type="text"
                                className="fieldinput"
                                value={
                                  SpecificProfile?.alternate === "no_class"
                                    ? SpecificProfile?.alternate?.replace(/_/g, " ")
                                    : SpecificProfile?.alternate
                                }
                                disabled
                              />
                            </div>
                          }
                          {SpecificProfile?.alternate === "arranged" ? (
                            <div className="col-lg-3">
                              <label className="labeltext">Alternate Person</label>
                              <input
                                type="text"
                                className="fieldinput"
                                value={SpecificProfile?.alternate_person_name}
                                disabled
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          <div className="col-lg-3">
                            <label className="labeltext">
                              Leaving Headquarters
                            </label>
                            <input
                              type="text"
                              className="fieldinput"
                              value={
                                SpecificProfile?.leaving_head_quaters !==
                                  undefined
                                  ? SpecificProfile.leaving_head_quaters
                                    .toString()
                                    .replace(/true/g, "Yes")
                                    .replace(/false/g, "No")
                                  : ""
                              }
                              disabled
                            />
                          </div>
                          {SpecificProfile?.leaving_head_quaters === true ? (
                            <div className="col-lg-3">
                              <label className="labeltext">Location</label>
                              <input
                                type="text"
                                className="fieldinput"
                                value={
                                  SpecificProfile?.location_during_leave_period
                                }
                                disabled
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                      {SpecificProfile?.reference_attachment ? (
                        <div className="col-lg-3">
                          <label className="labeltext">
                            Ref... (Attach Document)
                          </label>
                          <div className="fieldinputfile">
                            <span
                              className="namelink"
                              onClick={() => {
                                window.open(
                                  `${imagepath}${SpecificProfile?.reference_attachment}`,
                                  "_blank"
                                );
                              }}
                              target="_blank"
                            >
                              View Document
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="col-lg-3">
                        <label className="labeltext">Reason</label>
                        <textarea
                          type="text"
                          className="fieldinput"
                          value={SpecificProfile?.reason}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">Address - Leave Period</label>
                        <textarea
                          type="text"
                          className="fieldinput"
                          value={SpecificProfile?.address}
                          disabled
                        />
                      </div>
                    </>
                  }
                  {SpecificProfile?.hod_comment ? (
                    <div className="col-lg-3">
                      <label className="labeltext">Hod Comment</label>
                      <textarea
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.hod_comment}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.admin_comment ? (
                    <div className="col-lg-3">
                      <label className="labeltext">Admin Comment</label>
                      <textarea
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.admin_comment}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.director_comment ? (
                    <div className="col-lg-3">
                      <label className="labeltext">Director Comment</label>
                      <textarea
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.director_comment}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}

                  {SpecificProfile?.joining_report_details?.joining_date ? (
                    <>
                      <div className="col-lg-3">
                        <label className="labeltext">Rejoin Date</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={moment(
                            SpecificProfile?.joining_report_details
                              ?.joining_date
                          ).format("DD-MM-yyyy")}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">Rejoin Time</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={
                            SpecificProfile?.joining_report_details
                              ?.joining_time
                          }
                          disabled
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.joining_report_details
                    ?.medical_certificate ? (
                    <div className="col-lg-3">
                      <label className="labeltext">Medical Certificate</label>
                      <div className="fieldinputfile">
                        <span
                          className="namelink"
                          onClick={() => {
                            window.open(
                              `${imagepath}${SpecificProfile?.joining_report_details
                                ?.medical_certificate[0]}`
                            );
                          }}
                          target="_blank"
                        >
                          View Document
                        </span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.cancellation_hod_comment ? (
                    <div className="col-lg-3">
                      <label className="labeltext">
                        Hod Cancellation Comment
                      </label>
                      <textarea
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.cancellation_hod_comment}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.cancellation_admin_comment ? (
                    <div className="col-lg-3">
                      <label className="labeltext">
                        Admin Cancellation Comment
                      </label>
                      <textarea
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.cancellation_admin_comment}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.cancellation_director_comment ? (
                    <div className="col-lg-3">
                      <label className="labeltext">
                        Director Cancellation Comment
                      </label>
                      <textarea
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.cancellation_director_comment}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.joining_report_details?.hod_status === "approved" ? (
                    <div className="col-lg-3">
                      <label className="labeltext">
                        Hod rejoin Comment
                      </label>
                      <textarea
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.joining_report_details?.hod_comment}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.joining_report_details?.admin_status === "approved" ? (
                    <div className="col-lg-3">
                      <label className="labeltext">
                        Admin rejoin Comment
                      </label>
                      <textarea
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.joining_report_details?.admin_comment}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.joining_report_details?.director_status === "approved" ? (
                    <div className="col-lg-3">
                      <label className="labeltext">
                        Director rejoin Comment
                      </label>
                      <textarea
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.joining_report_details?.director_comment}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                {SpecificProfile?.nature_of_leave === "Out Of Station" ? (
                  ""
                ) : (
                  <>
                    {!SpecificProfile?.admin_comment ||
                      SpecificProfile?.cancellation_admin_status === "pending" ? (
                      <div className="row my-5">
                        <div className="col-lg-3 mx-auto my-auto centertext">
                          <button
                            className="approvebutton"
                            onClick={() => {
                              setStatusAcceptModel(true);
                            }}
                          >
                            Forword
                          </button>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                )}
                {SpecificProfile?.joining_report_details?.admin_status === "pending" ?
                  <div className="text-center mt-5">
                    <button className="approvebutton" onClick={() => setRejoinModal(true)}>
                      Approve
                    </button>
                  </div>
                  : ''
                }
              </div>
            </div>
          </div>
        </section>

        {/*  ApproveModal */}
        <CustomModal
          open={statusAcceptModel}
          onClickOutside={() => {
            setStatusAcceptModel(false);
            setCreateStatus({});
            setValidation({});
          }}
        >
          <form onSubmit={(e) => handleApproveSubmit(e)}>
            <div className="modal-content Modal-View m-auto">
              <div className="modalHeader text-center py-2">
                <h5 className="font-bold mt-2">Admin Comment</h5>
              </div>
              <div className="modal-body p-0">
                <div className="container">
                  <div className="row d-flex align-items-center justify-content-center  mt-0">
                    <div className="container ">
                      <div className="row justify-content-center">
                        <div className="col-lg-8">
                          <div className=" my-5 px-3">
                            <div className="row justify-content-center mt-2">
                              <div className="col-lg-10">
                                <div className="mb-3">
                                  <label className="labeltext">
                                    Admin Comment:
                                  </label>
                                  <textarea
                                    type="text"
                                    className="fieldinput"
                                    placeholder="Enter Comment"
                                    defaultValue={createStatus.admin_comment}
                                    onChange={(e) => {
                                      setData(e.target.value, "admin_comment");
                                    }}
                                  />
                                  {validation.admin_comment && (
                                    <p className="validationerror">
                                      {validation.admin_comment}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <div className="my-3">
                  <button
                    type="button"
                    className="btn mx-2 modelclosebtn"
                    onClick={() => {
                      setStatusAcceptModel(false);
                      setValidation({});
                      setCreateStatus({});
                    }}
                  >
                    Back
                  </button>
                </div>
                <div>
                  <button className="btn mx-2 modelsubmitbtn">Forward</button>
                </div>
              </div>
            </div>
          </form>
        </CustomModal>

        <CustomModal
          open={rejoinModal}
          onClickOutside={() => {
            setRejoinModal(false);
          }}
        >
          <form onSubmit={(e) => handleRejoinSubmit(e)}>
            <div className="modal-content Modal-View m-auto">
              <div className="modalHeader text-center py-2">
                <h5 className="font-bold mt-2">Admin Approve Status</h5>
              </div>
              <div className="modal-body p-0 ">
                <div className="container">
                  <div className="row d-flex align-items-center justify-content-center  mt-0">
                    <div className="container ">
                      <div className="row justify-content-center">
                        <div className="col-lg-8">
                          <div className=" my-5 px-3">
                            <div className="row justify-content-center mt-2">
                              <div className="col-lg-10">
                                <div className="mb-3">
                                  <label className="labeltext">
                                    Admin Comment:
                                  </label>
                                  <textarea
                                    type="text"
                                    className="fieldinput"
                                    placeholder="Enter Comment"
                                    defaultValue={rejoinComment}
                                    onChange={(e) => {
                                      setRejoinComment(e.target.value);
                                    }}
                                  />
                                  {rejoinValidation?.message && (
                                    <p className="validationerror">
                                      Comment {rejoinValidation?.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <div className="my-3">
                  <button
                    type="button"
                    className="btn mx-2 modelclosebtn"
                    onClick={() => {
                      setRejoinModal(false);
                    }}
                  >
                    Back
                  </button>
                </div>
                <div>
                  <button className="btn mx-2 approvebutton">Approve</button>
                </div>
              </div>
            </div>
          </form>
        </CustomModal>
      </div>
    </>
  );
};

export default AdminSpecificrequestview;
